/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information.
 *
 * The version of the OpenAPI document: 0.2.2
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ShipPositionResponse } from './ShipPositionResponse';
import {
    ShipPositionResponseFromJSON,
    ShipPositionResponseFromJSONTyped,
    ShipPositionResponseToJSON,
} from './ShipPositionResponse';

/**
 * 
 * @export
 * @interface ShipPositionPost200Response
 */
export interface ShipPositionPost200Response {
    /**
     * 
     * @type {Array<ShipPositionResponse>}
     * @memberof ShipPositionPost200Response
     */
    records?: Array<ShipPositionResponse>;
}

/**
 * Check if a given object implements the ShipPositionPost200Response interface.
 */
export function instanceOfShipPositionPost200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ShipPositionPost200ResponseFromJSON(json: any): ShipPositionPost200Response {
    return ShipPositionPost200ResponseFromJSONTyped(json, false);
}

export function ShipPositionPost200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShipPositionPost200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'records': !exists(json, 'records') ? undefined : ((json['records'] as Array<any>).map(ShipPositionResponseFromJSON)),
    };
}

export function ShipPositionPost200ResponseToJSON(value?: ShipPositionPost200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'records': value.records === undefined ? undefined : ((value.records as Array<any>).map(ShipPositionResponseToJSON)),
    };
}

